module.exports = __webpack_public_path__ + "static/media/footer-logo.bcb2a1e8.png";